"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Grahpql_1 = require("./src/components/Grahpql");
exports.GraphqlClient = Grahpql_1.GraphqlClient;
exports.GraphqlQuery = Grahpql_1.GraphqlQuery;
const index_1 = require("./src/lib/index");
exports.default = index_1.default;
//# sourceMappingURL=index.js.map